import styled from 'styled-components'
import { colorTheme } from '../../../../../../../style/theme/colorTheme'
import { theme } from '../../../../../../../style/theme'

export const InvoiceItemsTableWrap = styled.div`
	display: flex;
	flex-direction: column;
	border: 1px solid ${colorTheme.invoices.modal.invoiceData.tableBorder};
	border-radius: 0.5em;
	overflow: hidden;
	font-size: 1.25em;
`
InvoiceItemsTableWrap.displayName = 'InvoiceItemsTableWrap'

export const InvoiceItemsTableRow = styled.div`
	display: flex;
	border-bottom: 1px solid ${colorTheme.invoices.modal.invoiceData.tableBorder};

	&:last-child {
		border-bottom: none;
	}
`
InvoiceItemsTableRow.displayName = 'InvoiceItemsTableRow'

export const InvoiceItemsTableCell = styled.div`
	display: flex;
	flex-direction: column;
	justify-content: center;
	padding: 0.75em;
	border-right: 1px solid ${colorTheme.invoices.modal.invoiceData.tableBorder};
	word-break: break-word;

	&:last-child {
		border-right: none;
	}

	&.quantity {
		flex-shrink: 0;
		width: 7.5em;
	}

	&.name {
		flex: 1;
		min-width: 0;
	}

	&.price {
		flex-shrink: 0;
		width: 10em;
		align-items: flex-end;
		text-align: right;
	}

	&.head {
		font-family: ${theme.fontRobotoMedium};
		font-weight: 500;
	}
`
InvoiceItemsTableCell.displayName = 'InvoiceItemsTableCell'

export const InvoiceItemDetails = styled.div`
	padding-top: 0.25em;
	font-size: 0.8em;

	&.level-1 {
		padding-left: 1.25em;
	}
`
InvoiceItemDetails.displayName = 'InvoiceItemDetails'

export const InvoiceItemsBlocks = styled.div`
	display: flex;
	flex-direction: column;
	border-top: 1px solid ${colorTheme.invoices.modal.invoiceData.tableBorder};
`
InvoiceItemsBlocks.displayName = 'InvoiceItemsBlocks'

export const InvoiceItemBlock = styled.div`
	display: flex;
	flex-direction: column;
	border-bottom: 1px solid ${colorTheme.invoices.modal.invoiceData.tableBorder};
`
InvoiceItemBlock.displayName = 'InvoiceItemBlock'

export const InvoiceItemBlockRow = styled.div`
	display: flex;
	border-bottom: 1px solid ${colorTheme.invoices.modal.invoiceData.tableBorder};

	&:last-child {
		border-bottom: none;
	}
`
InvoiceItemBlockRow.displayName = 'InvoiceItemBlockRow'

export const InvoiceItemBlockCell = styled.div`
	display: flex;
	flex: 1;
	flex-direction: column;
	gap: 0.31em;
	min-width: 0;
`
InvoiceItemBlockCell.displayName = 'InvoiceItemBlockCell'

export const InvoiceItemBlockLabel = styled.div`
	padding: 0.67em 0 0.67em 0.33em;
	border-bottom: 1px dashed ${colorTheme.invoices.modal.invoiceData.tableBorder};
	font-family: ${theme.fontRobotoMedium};
	font-size: 0.94em;
	font-weight: 500;
`
InvoiceItemBlockLabel.displayName = 'InvoiceItemBlockLabel'

export const InvoiceItemBlockValue = styled.div`
	padding: 0.56em 0.33em;
	color: ${colorTheme.invoices.modal.invoiceData.tableValue};
	font-size: 1.13em;
	word-break: break-word;
`
InvoiceItemBlockValue.displayName = 'InvoiceItemBlockValue'
